import React, { Children } from 'react';
import { motion } from 'framer-motion';
const painPoints = [{
  emoji: '🤔',
  text: 'Te sientes hinchada después de cada comida'
}, {
  emoji: '😔',
  text: 'Tu ropa ajusta diferente cada día sin razón'
}, {
  emoji: '😩',
  text: 'Esa sensación de pesadez que no desaparece'
}, {
  emoji: '😤',
  text: 'Ya probaste de todo y nada funciona'
}, {
  emoji: '😰',
  text: 'Te despiertas cansada aunque dormiste bien'
}, {
  emoji: '🌀',
  text: 'Sientes tu abdomen tenso e incómodo'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function PainSection() {
  return <section className="bg-wellness-light-sage py-24 px-6" id="pain-points" data-id="element-78">
      <div className="max-w-7xl mx-auto" data-id="element-79">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-80">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-wellness-dark mb-4" data-id="element-81">
            ¿Te identificas con esto?
          </h2>
          <p className="text-lg text-wellness-dark/70 max-w-2xl mx-auto" data-id="element-82">
            No es normal vivir con incomodidad constante. Reconocer el problema
            es el primer paso para sentirte mejor.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-83">
          {painPoints.map((point, index) => <motion.div key={index} variants={itemVariants} className="bg-white rounded-2xl p-8 shadow-lg shadow-wellness-dark/5 flex flex-col items-center text-center space-y-4 hover:shadow-xl hover:-translate-y-1 transition-all duration-300" data-id="element-84">
              <div className="text-5xl mb-2" data-id="element-85">{point.emoji}</div>
              <p className="text-wellness-dark font-medium text-lg leading-relaxed" data-id="element-86">
                {point.text}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}